import { createI18n } from 'vue-i18n';
import localesConfig from '@config/locales.config';
import localsService from '@assets/services/locals.service';

type localeKey = 'EN' | 'JP' | 'ZH';

let locale = localsService.getLanguage();
if (typeof locale === 'object' && locale.key) locale = locale.key; // 迁移过来的档案可能是个对象

const fallbackLocale: string = (localesConfig as Array<any>).find(
    (locale: any) => locale.fallbackLocale
).key;

const messages = localesConfig.reduce((acc: any, cur: any) => {
    const { key, file }: { key: localeKey; file: File } = cur;
    acc[key] = Object.assign(file);
    return acc;
}, {});

const i18n = createI18n({
    locale,
    fallbackLocale,
    messages,
    globalInjection: true,
    t: (key: localeKey) => messages[locale](key)
});

export default i18n;

export const changeLocale = (locale: localeKey) => {
    locale !== i18n.global.locale && (i18n.global.locale = locale);
    if (['interactive', 'complete'].includes(document.readyState)) {
        updateFont();
    } else {
        window.addEventListener('DOMContentLoaded', updateFont, false);
    }
};

export function updateFont() {
    window.removeEventListener('DOMContentLoaded', updateFont, false);
    if (i18n.global.locale.toLocaleUpperCase() === 'ZH') {
        document.body.classList.add('lang-zh');
        document.body.classList.remove('lang-jp');
    } else {
        document.body.classList.add('lang-jp');
        document.body.classList.remove('lang-zh');
    }
}
